import { createFileIconMaps } from './maps/fileIconMaps';
import { createGeneralIconMaps } from './maps/generalIconMaps';
import { createIntegrationMaps } from './maps/integrationMaps';
import { createRelationsListMaps } from './maps/relationsListMaps';
import { createReportBillingSessionMaps } from './maps/reportBillingSessionMaps';
import { createRouteListIconMaps } from './maps/routeListIconMaps';
import { useCreationModalMaps } from './maps/useCreationModalMaps';
import { createWorkspacePermissionMaps } from './maps/workspacePermissionMaps';
import { useAntDesignTheme } from './useAntDesignTheme';

export const useMaps = () => {
    const { token } = useAntDesignTheme();

    return {
        ...useCreationModalMaps(),
        ...createGeneralIconMaps(token),
        ...createFileIconMaps(token),
        ...createRouteListIconMaps(),
        ...createIntegrationMaps(token),
        ...createWorkspacePermissionMaps(token),
        ...createRelationsListMaps(),
        ...createReportBillingSessionMaps(token),
    };
};
